<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.auction_management' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3"><span>{{ 'admin.n_matches' | transloco: {count: (auctions.totalCount | number)} }}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #auctionGrid [isReadOnly]="true" style="height:200px" [itemsSource]="auctions">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'admin.event_date' | transloco" [binding]="'eventDate'" [dataType]="'Date'" [width]="150" [isRequired]="true">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                        {{item['eventDate']| date: 'yyyy/MM/dd HH:mm:ss'}}
                                    </ng-template>
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-input-date class="cell-editor" [(value)]="cell.value" [format]="'yyyy/MM/dd HH:mm:ss'" [isRequired]="true"></wj-input-date>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.venue' | transloco" [binding]="'place'" [width]="150">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-combo-box class="cell-editor" [itemsSource]="optionPlace" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="true"></wj-combo-box>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.lane' | transloco" [binding]="'lane'" [width]="150">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-combo-box class="cell-editor" [itemsSource]="optionLane" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="true"></wj-combo-box>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.state' | transloco" [binding]="'status'" [width]="150">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                                        <wj-combo-box class="cell-editor" [itemsSource]="optionStatus" [(selectedValue)]="cell.value" [isEditable]="false" [isRequired]="true"></wj-combo-box>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.entry_fee' | transloco" [binding]="'entranceFee'" [dataType]="'Number'" [width]="100">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.tax_rate' | transloco" [binding]="'taxPercentage'" [dataType]="'Number'" [width]="100">
                                </wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="auctions.pageSize" [header]="'admin.page_size' | transloco">
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="auctions"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="auctions"></wj-collection-view-pager>
                        </div>
                    </div>
                    <div class="row">
                        <button *ngIf="!readonly" [disabled]="!auctions.hasChanges()" (click)="auctions.saveChanges()" class="btn btn-primary btn-block">{{ 'admin.save_changes' | transloco }}</button>
                        <button *ngIf="!readonly" [disabled]="!auctions.hasChanges()" (click)="auctions.cancelChanges()" class="btn btn-primary btn-block">{{ 'common.cancel' | transloco }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.auction_info' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <button (click)="createNew()" type="button" class="btn btn-block btn-primary">{{ 'admin.create_new' | transloco }}</button>
                        </div>
                        <div class="col-md-4">
                            <button (click)="editAuction()" type="button" class="btn btn-block btn-primary">{{ 'common.edit' | transloco }}</button>
                        </div>
                    </div>
                    <br>
                    <fieldset [disabled]="mode == 'view'">
                        <div class="form-group row">
                            <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.event_date' | transloco }}</label>
                            <div class="col-md-6">
                                <wj-input-date-time style="width:100%;" [(value)]="auction.eventDate" [format]="'yyyy/MM/dd HH:mm:ss'" [isRequired]="true" [placeholder]="'admin.event_date' | transloco"></wj-input-date-time>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.venue' | transloco }}</label>
                            <div class="col-md-6">
                                <select class="form-control" [(ngModel)]="auction.place">
                                    <option *ngFor="let item of optionPlace"
                                            [value]="item">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.lane' | transloco }}</label>
                            <div class="col-md-6">
                                <select class="form-control" [(ngModel)]="auction.lane">
                                    <option *ngFor="let item of optionLane" [value]="item">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.state' | transloco }}</label>
                            <div class="col-md-6">
                                <select class="form-control" [(ngModel)]="auction.status">
                                    <option *ngFor="let item of optionStatus" [value]="item">{{ item }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.entry_fee' | transloco }}</label>
                            <div class="col-md-6">
                                <input type="number" [(ngModel)]="auction.entranceFee" class="form-control" [placeholder]="'admin.entry_fee' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-6 form-control-label d-none d-lg-block">{{ 'admin.tax_rate' | transloco }}</label>
                            <div class="col-md-6">
                                <input type="number" [(ngModel)]="auction.taxPercentage" class="form-control" [placeholder]="'admin.tax_rate' | transloco">
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div *ngIf="mode == 'edit'" class="card-footer">
                    <div class="row">
                        <div class="col-md-6">
                            <button (click)="saveAuction()" class="btn btn-primary btn-block">{{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-md-6">
                            <button (click)="cancelAuction()" class="btn btn-danger btn-block">{{ 'common.cancel' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.listing_order_management' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <input class="form-control" type="number" [(ngModel)]="counter"/>
                        </div>
                        <div class="col-md-2">
                            <button (click)="applyCounter()" class="btn btn-success btn-block">{{ 'admin.assign_order' | transloco }}</button>
                        </div>
                        <div class="col-md-2">
                            <wj-combo-box style="width:100%;" [itemsSource]="optionAuction" [(ngModel)]="destination" [displayMemberPath]="'display'" [isRequired]="false"></wj-combo-box>
                        </div>
                        <div class="col-md-2">
                            <button (click)="applyAuction()" class="btn btn-success btn-block">{{ 'admin.move_to_auction' | transloco }}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3"><span>{{ 'admin.n_matches' | transloco: {count: (items.items.length | number)} }}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #itemGrid [isReadOnly]="false" style="height:500px" [itemsSource]="items">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'common.select' | transloco" [binding]="'$selected'" [dataType]="'Boolean'" [width]="100">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
                                        <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAllChange()"/>{{ 'common.select' | transloco }}
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='sort' [header]="'admin.sort_order' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='published' [header]="'admin.publish_date' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='id' [header]="'admin.item_id' | transloco" [dataType]="'Number'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='seller.memberName' [header]="'admin.seller' | transloco" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='sellerCharge' [header]="'admin.buyer_fee_rate' | transloco" [width]="80"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='lane' [header]="'admin.lane' | transloco" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='category' [header]="'admin.item_category' | transloco" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='auctionPrice' [header]="'admin.winning_price' | transloco" [dataType]="'Number'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='auctionResult' [header]="'admin.auction_result' | transloco" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='name' [header]="'admin.item_name' | transloco" [width]="150" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='description' [header]="'admin.item_description' | transloco" [width]="200" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='quantity' [header]="'admin.quantity' | transloco" [dataType]="'Number'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='unit' [header]="'admin.unit' | transloco" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='buyer.memberName' [header]="'admin.buyer' | transloco" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='buyerCharge' [header]="'admin.buyer_fee_rate' | transloco" [width]="80"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='minimumPrice' [header]="'admin.minimum_price' | transloco" [dataType]="'Number'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                                <wj-flex-grid-column binding='startPrice' [header]="'admin.start_price' | transloco" [dataType]="'Number'" [width]="80" [isReadOnly]="true"></wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <button *ngIf="this.items.itemsEdited.length > 0" (click)="saveItem()" class="btn btn-primary btn-block">{{ 'admin.save_changes' | transloco }}</button>
                        <button *ngIf="this.items.itemsEdited.length > 0" (click)="cancelItem()" class="btn btn-danger btn-block">{{ 'common.cancel' | transloco }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

